export const BLOCK_TYPE_ARTICLE_LIST_LATEST = 'articleListLatest';
